import { FeatureFlags } from '@frontegg/rest-api';
import { useShadowDom } from '../common';
export const useFeatureFlags = flags => {
  var _injector$name;
  const {
    injector
  } = useShadowDom();
  return FeatureFlags.getFeatureFlags(flags, (_injector$name = injector == null ? void 0 : injector.name) != null ? _injector$name : 'default');
};
export const useFeatureFlagsChecker = () => {
  const {
    injector
  } = useShadowDom();
  return flags => {
    var _injector$name2;
    return FeatureFlags.getFeatureFlags(flags, (_injector$name2 = injector == null ? void 0 : injector.name) != null ? _injector$name2 : 'default');
  };
};